import { handleActions } from 'redux-actions';
import { combineReducers } from 'redux';
import { merge } from 'lodash';
import * as R from 'ramda';
import * as substanceFunctionTypes from './substanceFunctionTypes';

const byId = handleActions(
  {
    [substanceFunctionTypes.SUBSTANCE_FUNCTION_LIST.SUCCESS]: (state, { payload }) =>
      merge({}, state, payload.entities.substanceFunctions),
    [substanceFunctionTypes.DELETE_SUBSTANCE_FUNCTION.SUCCESS]: (state, { payload }) => R.dissoc(payload, state),
  },
  {},
);

const allIds = handleActions(
  {
    [substanceFunctionTypes.SUBSTANCE_FUNCTION_LIST.SUCCESS]: (state, { payload }) => [
      ...new Set([...state, ...payload.result]),
    ],
    [substanceFunctionTypes.DELETE_SUBSTANCE_FUNCTION.SUCCESS]: (state, { payload }) => R.without([payload], state),
  },
  [],
);

export default combineReducers({
  byId,
  list: combineReducers({
    allIds,
  }),
});
